// extracted by mini-css-extract-plugin
export var divider = "_if-0";
export var labelWrapper = "_if-2";
export var lineSvg = "_if-1";